import { getStore, setStore, removeStore, clearStore } from '@/units/store'
import userApi from '@/api/user';

const user = {
  id: 'user',
  namespaced: true,
  state: {
    token: getStore({ name: 'token' }) || '',
    is_login: !!(getStore({ name: 'token' }) || ''),
    expires_in: getStore({ name: 'expires_in' }) || '',
    userInfo: getStore({ name: 'userInfo' }) || '',
  },
  actions: {
    async Login({ commit, dispatch }, accountData) {
      await userApi.accountLogin(accountData)
      await dispatch('GetUserInfo')
    },
    async Logout({ commit, dispatch }) {
      await userApi.logout()
      commit('CLEAR_TOKEN')
    },
    /*获取USER信息*/
    async GetUserInfo({ commit, dispatch }) {
      const {data} = await userApi.profile()
      commit('SET_USER_INFO', { user: data })
    },
    async UpdateUserInfo({ commit, dispatch }, data) {
      await userApi.update(data)
      await dispatch('GetUserInfo')
    }
  },
  mutations: {
    SET_USER_INFO: (state, { user }) => {
      state.userInfo = user
      setStore({
        name: 'userInfo',
        content: user
      })
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      state.is_login = !!token;
      setStore({
        name: 'token',
        content: token
      })
      console.log('SET_TOKEN ===== ', token)
    },
    SET_EXPIRES_IN: (state, expires_in) => {
      let data = Date.now() + expires_in * 1000;
      state.expires_in = data;
      setStore({
        name: 'expires_in',
        content: data
      })
    },
    CLEAR_TOKEN: (state) => {
      state.token = '';
      removeStore({name: 'token'})
      removeStore({name: 'expires_in'})
      removeStore({name: 'userInfo'})
	  // clearStore()
    }
  }
}
export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js